import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import helpImg1 from '../../assert/images/recharge_help.png'
import helpImg2 from '../../assert/images/recharge_help2.png'

class ClubChargeHelp extends React.Component {
  state = {
    loading: true,
  }

  render() {
    return (
      <div
        style={{
          padding: '40px',
        }}
      >
        <div>
          <img src={helpImg1}></img>
        </div>

        <div
          style={{
            fontSize: '16px',
            margin: '20px 0',
            fontWeight: 'bold',
          }}
        >
          绿色是已选择，白色是未选择。
        </div>

        <div
          style={{
            fontSize: '16px',
            margin: '20px 0',
            fontWeight: 'bold',
          }}
        >
          开启“全场球台显示”或者已选择的桌台，则对应桌台的扫码开台页会显示该充值赠送信息。
        </div>

        <div>
          <img src={helpImg2}></img>
        </div>
      </div>
    )
  }
}
export default withRouter(ClubChargeHelp)



// WEBPACK FOOTER //
// ./src/containers/ClubChargeHelp/index.js